import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuthorization from './useAuthorization'
import QuadrantLoader from '../loaders/quadrant-loader/QuadrantLoader'
import AccessDeniedPage from '../../pages/access-denied/AccessDeniedPage'
import Routes from '../../constants/routes'
import userSelectors from '../../store/selectors/user.selectors'
import { useSelector } from 'react-redux'

const AuthorizedRoute = ({ roles, types, children, senseUserOnly }) => {
    const { isAuthorized, isLoggedIn, loading } = useAuthorization(roles, types)
    const isSenseUser = useSelector(userSelectors.isSenseUser)
    const location = useLocation()

    if (loading) {
        return <QuadrantLoader />
    }

    if (senseUserOnly && !isSenseUser) {
        return <AccessDeniedPage />
    }

    if (isAuthorized) {
        return children
    } else if (isLoggedIn) {
        return <AccessDeniedPage />
    } else {
        return <Navigate to={Routes.LOGIN} state={{ from: location }} replace />
    }
}

export default AuthorizedRoute
